(function() {
  "use strict";

    angular.module("eSign")
  // Click to navigate
  // similar to <a href="#/partial"> but hash is not required,
  // e.g. <div click-link="/partial">
  .directive('clickLink', ['$window', function($window) {
      return {
          link: function(scope, element, attrs) {
              element.on('click', function() {
                  scope.$apply(function() {
                      $window.location.href = attrs.clickLink;
                  });
              });
          }
      }
  }]);
}());
